import { defineMessage } from 'services/localization';

export const messages = {
    templateNotFound: defineMessage('template_not_found'),
    errorLoadingSubscriptionExpiredText: defineMessage('sorry_we_could_not_load_ubscription_has_expired'),
    errorLoadingTrialExpiredText: defineMessage('sorry_we_could_not_load_ryour_trial_has_expired'),
    errorLoadingText: defineMessage('sorry_we_could_not_load_the_data'),
};
